import React from 'react';
import styled from 'styled-components';

import { RadiusOption } from 'types/graphql';
import { useGetCustomCategoryLink } from 'src/dispensary/hooks/use-get-custom-category-link';
import { ConditionalLink } from 'src/utils/conditional-link';

import { Category } from '../categories-nav.types';

const radiusOptions = {
  [RadiusOption.rounded]: '9999px',
  [RadiusOption.roundedRectangle]: '12px',
  [RadiusOption.square]: 0,
};

type TextCardProps = {
  category: Category;
  style: RadiusOption;
  isMobileGrid: boolean;
};

export const TextCard = ({ category, style, isMobileGrid }: TextCardProps): JSX.Element => {
  const { key, label, slug, customCategory, isOutlet } = category;

  const href = useGetCustomCategoryLink(customCategory, slug, key);

  return (
    <ConditionalLink url={href}>
      <Anchor href={href} $radius={style} $isMobileGrid={isMobileGrid} data-testid='category-list-link'>
        <Label $isOutlet={isOutlet}>{label}</Label>
      </Anchor>
    </ConditionalLink>
  );
};

const Anchor = styled.a`
  background: #fff;
  border: 2px solid #e3e7e9;
  border-radius: ${({ $radius }) => radiusOptions[$radius]};
  color: #121516;
  display: block;
  font-size: 16px;
  font-weight: 600;
  line-height: ${24 / 16};
  padding: ${({ $isMobileGrid }) => ($isMobileGrid ? `12px 5px` : `12px 20px`)};
  text-align: center;
  transition: border 0.2s;
  white-space: nowrap;

  @media screen and (min-width: 600px) {
    padding: 12px 20px;
  }

  &:hover {
    border-color: #646d72;
  }
`;

const Label = styled.h3<{ $isOutlet?: boolean }>`
  margin: 0;
  ${({ $isOutlet }) =>
    $isOutlet &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;
